import React from "react";
export const forestDepartmentLogo = "https://cdn.magicpatterns.com/uploads/47RXSjqRJg8BkHNYv5tC5R/Bangladesh_GOV_logo_2.png";
type ForestLogoProps = {
  size?: "sm" | "md" | "lg";
  dark?: boolean;
  showLabel?: boolean;
};
export function ForestLogo({
  size = "md",
  dark = false,
  showLabel = false
}: ForestLogoProps) {
  const dimensions = size === "sm" ? "h-9 w-9" : size === "lg" ? "h-28 w-28" : "h-14 w-14";
  return <div className="flex items-center gap-2" data-id="element-88" data-mp="2pg4p8lvbzk8b"><img src={forestDepartmentLogo} alt="বন অধিদপ্তর" className={`${dimensions} object-contain`} data-id="element-89" data-mp="2pcz23c69isf8" />{showLabel && <span className={`text-xs font-bold leading-4 ${dark ? "text-white" : "text-[#176B3A]"}`} data-id="element-90" data-mp="2ke5nfgf8ovdh">বন অধিদপ্তর<br data-id="element-91" data-mp="2z6po8aex2qrr" /><span className="font-normal" data-id="element-92" data-mp="2ue69390kznku">বাংলাদেশ</span></span>}</div>;
}